var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentFarm && _vm.currentFarm.farmType == 2)?_c('farm-base-info',{attrs:{"currentMapInfo":_vm.currentFarm}}):_vm._e(),(_vm.currentFarm && _vm.currentFarm.farmType == 3)?_c('farm-use',{attrs:{"current-farm":_vm.currentFarm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }